

<div class="row">
  <div class="col-lg-12" style="height: 800px;">
    <ac-map>
      <app-cylinder-layer></app-cylinder-layer>
    </ac-map>
  </div>
</div>
